import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TemporalityWidths } from '../../chartmap-mosaic-shared';

@Component({
  selector: 'app-event-analytics-temporality',
  templateUrl: './event-analytics-temporality.component.html',
  styleUrls: ['./event-analytics-temporality.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventAnalyticsTemporalityComponent {
  @Input() widths: TemporalityWidths | null = null;
}
